module.exports = __webpack_public_path__ + "img/rebound_bronze.e03b8765.svg";